/* __next_internal_client_entry_do_not_use__ SDUIProductTileEvaluateRenderer auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { ProductTile } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/ProductTile";
import { ProductTileType } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/ProductTileType";
import { useTraceComponentRender } from "@faire/web--source/common/tracing/useTraceComponentRender";
import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";
import React from "react";
export var SDUIProductTileEvaluateRenderer = function(param) {
    var product = param.product, brand = param.brand;
    useTraceComponentRender("ProductTileItem");
    return /*#__PURE__*/ _jsx(ProductTile, {
        productTile: product,
        productTileType: ProductTileType.SDUI_EVALUATE,
        brand: ILeanProductTile.IBrand.build(brand)
    });
};
